import { Formik, Form } from "formik";
import { TextField, Button, Box, Alert } from "@mui/material";
import { companyValidationSchema } from "../../utils/validations";

export const CompanyForm = ({
  initialValues,
  onSubmit,
  isSubmitting,
  submitLabel = "Add Company",
  showActions = true,
  onCancel,
}) => {
  const defaultValues = {
    name: "",
    phone: "",
    website: "",
  };

  return (
    <Formik
      initialValues={initialValues || defaultValues}
      validationSchema={companyValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        isSubmitting: formSubmitting,
      }) => (
        <Form>
          <TextField
            fullWidth
            name="name"
            placeholder="Company Name *"
            value={values.name}
            autoFocus
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.name && Boolean(errors.name)}
            helperText={touched.name && errors.name}
            sx={{
              mb: 2,
              borderRadius: "12px",
              "& .MuiInputBase-root": {
                height: "44px",
                borderRadius: "12px",
              },
            }}
          />
          <TextField
            fullWidth
            name="phone"
            placeholder="Phone Number"
            value={values.phone}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.phone && Boolean(errors.phone)}
            helperText={touched.phone && errors.phone}
            sx={{
              mb: 2,
              borderRadius: "12px",
              "& .MuiInputBase-root": {
                height: "44px",
                borderRadius: "12px",
              },
            }}
          />
          <TextField
            fullWidth
            name="website"
            placeholder="Website"
            type="url"
            value={values.website}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.website && Boolean(errors.website)}
            helperText={touched.website && errors.website}
            sx={{
              borderRadius: "12px",
              "& .MuiInputBase-root": {
                height: "44px",
                borderRadius: "12px",
              },
            }}
          />

          <Alert severity="info" sx={{ mt: 2 }}>
            💡 <strong>Quick Add:</strong> You can add more details later from
            the Companies page
          </Alert>

          {showActions && (
            <Box sx={{ display: "flex", gap: 2, mt: 3 }}>
              {onCancel && (
                <Button
                  variant="outlined"
                  fullWidth
                  onClick={onCancel}
                  disabled={isSubmitting || formSubmitting}
                >
                  Cancel
                </Button>
              )}
              <Button
                variant="contained"
                fullWidth
                type="submit"
                disabled={isSubmitting || formSubmitting}
                sx={{
                  bgcolor: "#6366f1",
                  borderRadius: "12px",
                  textTransform: "capitalize",
                }}
              >
                {isSubmitting || formSubmitting ? "Adding..." : submitLabel}
              </Button>
            </Box>
          )}
        </Form>
      )}
    </Formik>
  );
};
